<template>
  <v-container fluid>
    <!-- Encabezado principal -->
    <v-col cols="12" md="10" lg="8">
      <h2 class="header-title-int">
        ¡Hola, {{ this.getName || '' }}! Te damos la bienvenida de nuevo.
      </h2>
      <p class="header-subtitle grey--text">
        Gracias por confiar en nosotros. ¡Disfruta tu sesión!
      </p>
    </v-col>
    <v-row justify="center">
      <!-- Tarjeta de Membresía -->
      <v-col cols="12" sm="7" md="7">
        <v-card class="ma-2" outlined>
          <!-- Título principal -->
          <v-card-title class="text-h6 azul_med white--text">
            <v-icon color="white" class="mr-2">mdi-key-star</v-icon>
            Membresía <br /> {{ Membresia.IdTarjeta }}
          </v-card-title>

          <!-- QR -->
          <qr-user :id="getIdTarjetaTxt" />

          <!-- Estatus -->
          <v-card-text class="text-center">
            {{ Membresia.Estatus }}
          </v-card-text>

          <!-- Plan y Titular -->
          <v-card-title class="text-center text-h6">
            {{ Membresia.Plan }}
          </v-card-title>
          <v-card-subtitle class="text-center grey--text">
            {{ Membresia.TitularNombre }}
          </v-card-subtitle>

          <!-- Detalles -->
          <v-card-text>
            <p>
              <strong>Estatus:</strong>
              <span class="green--text font-weight-bold">{{ Membresia.Estatus }}</span><br />

              <strong>Número:</strong> {{ Membresia.IdTarjeta }}<br />

              <strong>Monto urgencias:</strong>
              <span class="blue--text font-weight-bold">
                {{ formatCurrency(Membresia.MontoUrgencias) }}
              </span><br />

              <strong>Pases médicos disponibles:</strong> {{ Membresia.NumCitas }}<br />

              <strong>Vigencia inicio:</strong> {{ formatFecha(Membresia.FecIniVigTxt) }}<br />
              <strong>Vigencia fin:</strong> {{ formatFecha(Membresia.FecVigenciaFinalTxt) }}<br />
            </p>

            <p v-if="Membresia.Colectivo">
              <strong>Colectividad:</strong> {{ Membresia.Colectivo }}
            </p>
            <p>
              <strong>Mis beneficiarios:</strong>
            </p>
            <list-beneficiados :membresia="Membresia.IdTarjeta" />
          </v-card-text>

          <!-- Botones de acción -->
          <!-- <v-card-actions class="justify-center">
        <v-btn color="primary" @click="editarDatos">
          <v-icon left>mdi-pencil</v-icon> Editar datos
        </v-btn>
        <v-btn color="secondary" @click="verHistorial">
          <v-icon left>mdi-file-document</v-icon> Ver historial
        </v-btn>
      </v-card-actions> -->
        </v-card>
      </v-col>

      <!-- Listado de Beneficiados -->
      <v-col cols="12" sm="5">
        <v-card class="ma-2" outlined>
          <v-card-title class="text-h6 azul_med white--text">
            <v-icon color="white" class="mr-2">mdi-account-multiple</v-icon>
            Mis datos de contacto
          </v-card-title>
          <v-card-text>
            Manten actualizados tus datos de <strong>contacto</strong>, para recibir notificaciones de promociones
            exclusivas, recibos de pago y facturas.
            <v-form>
              <v-row class="mt-2">
                <v-col cols="12">
                  <v-text-field v-model="Membresia.ContEmail" label="Correo"
                    :rules="[rules.ruleEmail, rules.ruleRequired]" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Teléfono" v-model="Membresia.ContNumTel"
                    :rules="[rules.ruleTelephon, rules.ruleRequired]" outlined dense v-mask="'### ### ####'"
                    placeholder="444 655 2222"></v-text-field>
                </v-col>

                <v-col cols="6" xs="6" sm="3" md="3" lg="2" xl="2">
                  <v-btn color="primary" @click="actualizarContacto" dense outlined>
                    Actualizar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <!-- Botones de acción (opcional) -->
          <!-- <v-card-actions class="justify-center">
        <v-btn color="info" @click="agregarBeneficiado">
          <v-icon left>mdi-account-plus</v-icon> Agregar beneficiado
        </v-btn>
      </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>
    <v-col cols="12" md="10" lg="8">
      <h2 class="header-title-int">
        Hospitales disponibles para urgencias médicas
      </h2>
      <p class="header-subtitle grey--text">
        En caso de <strong>emergencia médica</strong>, puedes acudir a cualquiera de los siguientes hospitales que
        forman
        parte de nuestra red de atención:
      </p>
    </v-col>
    <v-row dense>
      <v-col v-for="(image, index) in redhospitalaria" :key="index" cols="4" sm="4" md="3" lg="3" xl="2">
        <v-card v-show="image.membresia === Membresia.Plan" class="ma-2" outlined>
          <v-img :src="image.src" :alt="image.alt" height="80" contain></v-img>

          <v-card-subtitle class="text-center">
            <v-btn :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(image.direccion)}`"
              target="_blank" text color="primary" small block>
              Dirección
            </v-btn>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-card flat>
      <p class="text-subtitle-1 mb-1">
        Si tienes dudas, comunícate con tu agente de confianza:
      </p>

      <div class="text-body-1 font-weight-medium mb-1">
        <v-icon left color="primary">mdi-account</v-icon>
        {{ Membresia.Agente }}
      </div>

      <div class="text-body-2 mb-1">
        <v-icon left small color="primary">mdi-email</v-icon>
        <a :href="`mailto:${Membresia.AgeMail}`" class="text--primary">{{ Membresia.AgeMail }}</a>
      </div>

      <div class="text-body-2">
        <v-icon left small color="primary">mdi-phone</v-icon>
        <a :href="`tel:${Membresia.AgeTel}`" class="text--primary">{{ Membresia.AgeTel }}</a>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import formatFecha from '@/mixins/formatFecha';
export default {
  name: 'InicioCliente',
  mixins: [formatFecha],
  components: {
    QrUser: () => import('@/components/QRmembresiaComponent.vue'),
    ListBeneficiados: () => import('@/components/tableBeneficiados.vue')
  },
  created() {
    this.getMembresia()
  },
  data: () => ({
    Membresia: {
      IdTarjeta: '',
      IdTarjetaTxt: '',
      IdUsuario: '',
      FecVigencia: '',
      FecVigenciaFinalTxt: '',
      Estatus: 'INACTIVO',
      NumCitas: 0,
      NumBeneficiados: 0,
      MontoUrgencias: 0,
      AgeNombre: '',
      AgeMail: '',
      AgeTel: '',
      TitularNombre: '',
      TelContacto: '',
      EmailContacto: '',
      UpdateContacto: '',
      Plan: '',
      NomContratante: '',
      Colectivo: null,
      Beneficiados: [],
      ContEmail: null,
      ContNumTel: null

    },
    redhospitalaria: [

      { src: "https://medicover.mx/img/Logolabene.png", alt: "Imagen 3", direccion: "Av. Venustiano Carranza 1090, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "PLUS - FAMILIAR" },
      {
        src: "https://medicover.mx/img/LogHospitalAngeles.webp", alt: "Imagen 1", direccion: "Antonio Aguilar 155, Burocratas del Estado, 78213 San Luis Potosí, S.L.P.",
        membresia: "PLUS - FAMILIAR"
      },
      { src: "https://medicover.mx/img/LogoST.svg", alt: "Imagen 2", direccion: "Mariano Arista 735, Barrio de Tequisquiapan, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "PLUS - FAMILIAR" },
      { src: "https://medicover.mx/img/logohs.png", alt: "Imagen 4", direccion: "Av. Benito Juarez 1210, Valle Dorado, 78399 San Luis Potosí, S.L.P.", membresia: "PLUS - FAMILIAR" },
      { src: "https://medicover.mx/img/logolomas.png", alt: "Imagen 5", direccion: "Imagen 5", membresia: "PLUS - FAMILIAR" },

      { src: "https://medicover.mx/img/Logolabene.png", alt: "Imagen 3", direccion: "Av. Venustiano Carranza 1090, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "FAMILIAR CORP. FW" },
      { src: "https://medicover.mx/img/Logolabene.png", alt: "Imagen 3", direccion: "Imagen 3", membresia: "INDIVIDUAL CORP. FW" },



      /**INDIVIDUAL CORPORATIVA DE SELLOS Y RETENES */
      { src: "https://medicover.mx/img/Logolabene.png", alt: "Imagen 3", direccion: "Av. Venustiano Carranza 1090, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "INDIVIDUAL - CORPORATIVA" },
      { src: "https://medicover.mx/img/LogoST.svg", alt: "Imagen 3", direccion: "Mariano Arista 735, Barrio de Tequisquiapan, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "INDIVIDUAL - CORPORATIVA" },
      { src: "https://medicover.mx/img/logohs.png", alt: "Imagen 3", direccion: "Av. Benito Juarez 1210, Valle Dorado, 78399 San Luis Potosí, S.L.P.", membresia: "INDIVIDUAL - CORPORATIVA" },

      { src: "https://medicover.mx/img/Logolabene.png", alt: "Imagen 3", direccion: "Av. Venustiano Carranza 1090, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "FAMILIAR - CORPORATIVA" },
      { src: "https://medicover.mx/img/LogoST.svg", alt: "Imagen 3", direccion: "Mariano Arista 735, Barrio de Tequisquiapan, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "FAMILIAR - CORPORATIVA" },
      { src: "https://medicover.mx/img/logohs.png", alt: "Imagen 3", direccion: "Av. Benito Juarez 1210, Valle Dorado, 78399 San Luis Potosí, S.L.P.", membresia: "FAMILIAR - CORPORATIVA" },



      {
        src: "https://medicover.mx/img/LogHospitalAngeles.webp", alt: "Imagen 1",
        direccion: "Antonio Aguilar 155, Burocratas del Estado, 78213 San Luis Potosí, S.L.P.", membresia: ""
      },
      { src: "https://medicover.mx/img/LogoST.svg", alt: "Imagen 2", direccion: "Mariano Arista 735, Barrio de Tequisquiapan, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.", membresia: "" },

      { src: "https://medicover.mx/img/logohs.png", alt: "Av. Benito Juarez 1210-CONSULTORIO 205, SEGUNDO, 78399 PISOs Potosí, S.L.P.", direccion: "Imagen 4", membresia: "" },
      { src: "https://medicover.mx/img/logolomas.png", alt: "Imagen 5", direccion: "Imagen 5", membresia: "" },
    ],
  }),
  mounted() {
  },
  computed: {
    ...mapGetters(['getIdTarjetaTxt', 'getIdTarjeta', 'getName']),
    formattedMonto() {
      // Formatea el monto como moneda
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(this.Membresia.MontoUrgencia);
    },
    formattedDate() {
      // Formatea la fecha solo al formato deseado (YYYY-MM-DD)
      if (!this.Membresia.FecVigencia) return '';
      return this.Membresia.FecVigencia.split('T')[0]; // Quita hora, minuto, segundos
    },
    rules() {
      return this.$rules;
    },
  },
  methods: {
    formatCurrency(amount) {
      return this.$formatCurrency(amount);
    },
    actualizarContacto() {
      const nuevoValor = this.getIdTarjeta;
      if (this.Membresia.ContNumTel && this.Membresia.ContEmail) {
        this.$http.put(`Membresia/updateContacto`, {
          GUID: nuevoValor,
          NumTel: this.Membresia.ContNumTel,
          Email: this.Membresia.ContEmail
        })
          .then(response => {
            if (response.status === 200) {

              this.$swal.fire({
                position: 'top-end',
                title: 'Correcto',
                text: 'Se guardaron los datos',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              })

            }
          })
          .catch(() => {
            this.$swal.fire({
              position: 'center',
              html: `Ups, tuvimos un error no esperado <b>intenta más tarde</b> .`,
              icon: 'error',
              confirmButtonText: 'Cerrar',
              showCloseButton: true,
              showConfirmButton: true,
              backdrop: false
            })
          });
      }
    },
    updateMonto(value) {
      // Convierte el valor del input en un número sin formato
      const rawValue = parseFloat(value.replace(/[^\d.-]/g, '')) || 0;
      this.Membresia.MontoUrgencia = rawValue;
    },
    updateDate(value) {
      // Mantener solo la fecha (YYYY-MM-DD)
      const formatted = value.split('T')[0]; // Quita hora, minuto, segundos
      this.Membresia.FecVigencia = formatted;
    },
    getMembresia() {
      this.$http.get(`membresia/detalle?id=${this.getIdTarjeta}`)
        .then(response => {
          if (response.status === 200) {
            this.Membresia = response.data
          }
        })
        .catch(() => {
        });
    }
  }
};                                      
</script>
<style scoped>
.contact-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.contact-info v-icon {
  margin-right: 8px;
}
</style>